/**
 * Tiny query-string encoder. Avoids pulling in the npm `qs` package for
 * the handful of `?limit=&offset=&site_id=` params B1.x needs.
 *
 * Drops undefined / null / empty-string values; URL-encodes keys + values.
 */
export function qs(
  params?: Record<string, string | number | boolean | undefined | null>,
): string {
  if (!params) return "";
  const pairs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  return pairs.length ? `?${pairs.join("&")}` : "";
}
